var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25684 13.4688C7.25684 13.8516 6.95605 14.1251 6.60059 14.1251H4.63184C3.15527 14.1251 2.00684 12.9766 2.00684 11.5001V4.50006C2.00684 3.05084 3.15527 1.87506 4.63184 1.87506H6.60059C6.95605 1.87506 7.25684 2.17584 7.25684 2.53131C7.25684 2.91412 6.95605 3.18756 6.60059 3.18756H4.63184C3.89355 3.18756 3.31934 3.78912 3.31934 4.50006V11.5001C3.31934 12.2383 3.89355 12.8126 4.63184 12.8126H6.60059C6.95605 12.8126 7.25684 13.1133 7.25684 13.4688ZM15.8154 7.56256L12.3428 3.84381C12.0967 3.57037 11.6865 3.57037 11.4131 3.81647C11.1396 4.06256 11.1396 4.47272 11.3857 4.74615L13.8193 7.34381H7.01074C6.65527 7.34381 6.38184 7.64459 6.38184 8.00006C6.38184 8.38287 6.65527 8.65631 7.01074 8.65631H13.792L11.3311 11.2813C11.085 11.5547 11.085 11.9649 11.3584 12.211C11.5225 12.3204 11.6865 12.3751 11.8232 12.3751C11.9873 12.3751 12.1514 12.3204 12.2881 12.1837L15.7607 8.4649C16.0615 8.21881 16.0615 7.80865 15.8154 7.56256Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLogoutIcon);
export default __webpack_public_path__ + "static/media/modal-logout-icon.76e03f11dbb8fa517167d850181e1029.svg";
export { ForwardRef as ReactComponent };